import React from 'react';

import PropTypes from 'prop-types';

import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

const VersionSetCell = ({ rowData = {}, isDisabled }) => (
  <OverflowTooltip
    autoTipOnEllipsis
    style={{ zIndex: 9999 }}
    content={rowData.versionSet?.name}
    variant={OverflowTooltip.VARIANTS.LIGHT}
  >
    <span style={{ color: isDisabled && theme.colors.charcoal500 }}>
      {rowData.versionSet?.name || ''}
    </span>
  </OverflowTooltip>
);

VersionSetCell.propTypes = {
  rowData: PropTypes.shape({
    versionSet: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  isDisabled: PropTypes.bool,
};

export default VersionSetCell;
